module.exports = __webpack_public_path__ + "img/2.ed3a391a.jpg";